import styled from "styled-components";
import PhoneHand from "../../../assets/img/Section-phone.png";
import BgDecor from "../../../assets/img/Section-background.png";
import BgDecorMobile from "../../../assets/img/Section-background-mobile.png";
import GooglePlayLogo from "../../../assets/img/Section-store.png";
import BrIcon from "../../../assets/img/Section-icon.png";

import { DARK_KUBBE, PRIMARY_KUBBE } from "../../../constants/Colors";
import { playUrl } from "../../Dashboard/components/AppLink/AppLink";

const HeroSectionWrapper = styled.section`
  position: relative;
  width: 100%;
  aspect-ratio: 1840/879;
  background: ${PRIMARY_KUBBE};
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  @media (max-width: 768px) {
    aspect-ratio: 990/1408;
    border-radius: 0px;
    height: auto;
    background: transparent;
    background-image: linear-gradient(
      to bottom,
      transparent 0%,
      transparent 15%,
      ${PRIMARY_KUBBE} 15%,
      ${PRIMARY_KUBBE} 85%,
      transparent 85%,
      transparent 100%
    );
    box-shadow: 0px 0px 0px;
  }
`;

const BgDecoration = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  background-image: url(${BgDecor});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  @media (max-width: 768px) {
    background-image: url(${BgDecorMobile});
  }
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    justify-content: flex-start;
  }
`;

const TextContent = styled.div`
  width: 50%;
  max-width: 700px;

  margin-left: 5%;
  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    padding: 1rem;
  }

  h1 {
    font-size: clamp(2rem, 5vw, 5rem);
    font-weight: bold;
    margin: 0;
    color: ${DARK_KUBBE};
  }

  p {
    font-size: clamp(2rem, 4vw, 4.5rem);
    font-weight: bold;
    margin: 1rem 0 2rem;
    color: white;
    @media (max-width: 768px) {
      font-size: clamp(1.5rem, 8vw, 3rem);
    }
  }
`;

const GooglePlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  margin-left: 5%;
  margin-bottom: 2.5%;
  width: 15%;
  z-index: 2;
  @media (max-width: 768px) {
    position: relative;
    margin-right: auto;
    bottom: unset;
    left: unset;
    width: 40%;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;

    &:hover {
      opacity: 0.85;
    }
  }
`;

const IconContainer = styled.div`
  width: 50%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;

    &:hover {
      opacity: 0.85;
    }
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
  height: 100%;
  aspect-ratio: 1.456;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    position: absolute;
    top: unset;
    bottom: 0;
    right: 0;
    width: 100%;
    height: auto;
  }
`;

const HeroSlide1 = () => {
  return (
    <HeroSectionWrapper>
      <BgDecoration />

      <ContentWrapper>
        <TextContent>
          <IconContainer>
            <a href={playUrl} target="_blank" rel="noopener noreferrer">
              <img src={BrIcon} alt="Disponible en Google Play" />
            </a>
          </IconContainer>
          <p>La nueva forma de gestionar cargas y viajes en Argentina</p>
        </TextContent>

        <GooglePlay>
          <a href={playUrl} target="_blank" rel="noopener noreferrer">
            <img src={GooglePlayLogo} alt="Disponible en Google Play" />
          </a>
        </GooglePlay>

        <ImageWrapper>
          <img src={PhoneHand} alt="Aplicación en el celular" />
        </ImageWrapper>
      </ContentWrapper>
    </HeroSectionWrapper>
  );
};

export default HeroSlide1;
